import styled from 'styled-components';

const LabelAuthentication = styled.label`
  font-size: 24px;
  font-weight: lighter;
`;

export default LabelAuthentication;
